import React from 'react';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Divider,
  Grid,
  TextField,
} from '@mui/material';
import { Address } from '../../types/address';

interface SenderAddressProps {
  senderAddress: Address;
  onSenderAddressChange: (field: string, value: string) => void;
}

export const SenderAddress: React.FC<SenderAddressProps> = ({
  senderAddress,
  onSenderAddressChange,
}) => {
  
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        Sender Address
      </Typography>

      <Grid container spacing={4}>
        <Grid item xs={12} md={4}>
        <Typography variant="body1" color="text.secondary" paragraph>
          Add your return address.
        </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Full Name"
                value={senderAddress.name}
                onChange={(e) => onSenderAddressChange('name', e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Address Line 1"
                value={senderAddress.address_line1}
                onChange={(e) => onSenderAddressChange('address_line1', e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Address Line 2 (Optional)"
                value={senderAddress.address_line2}
                onChange={(e) => onSenderAddressChange('address_line2', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="City"
                value={senderAddress.address_city}
                onChange={(e) => onSenderAddressChange('address_city', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="State"
                value={senderAddress.address_state}
                onChange={(e) => onSenderAddressChange('address_state', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Postal Code"
                value={senderAddress.address_zip}
                onChange={(e) => onSenderAddressChange('address_zip', e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Country"
                value={senderAddress.address_country}
                onChange={(e) => onSenderAddressChange('address_country', e.target.value)}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}; 